/* eslint-disable consistent-return */

import Component from '@bythepixel/component-loader';
import { eventThrottle } from '@Core/utility';
import { addSnackbar } from '@Utility/snackbar';
import { SNACKBAR_TEMPLATES } from '@Core/components/snackbarController/config';

export default class FavoriteButton extends Component {
  static selector = '[data-comp-favorite]';
  static counterSelector = '[data-comp-favorite-count]';

  static saveClass = '.favorite-button__text';
  static activeClass = 'favorite-button--active';

  constructor(containerEl, options) {
    super(containerEl, options);

    this.favoriteProduct = this.$container.dataset.favoriteProduct;

    if (!this.favoriteProduct) return;

    this.stockId = this.$container.dataset.stockId;

    const throttledToggleFavorite = eventThrottle(
      () => this.toggleFavorite(),
      500,
    );

    this.$container.addEventListener('click', (event) => {
      // prevents propagation to vehicle card as soon as possible
      event.stopPropagation();

      throttledToggleFavorite();
    });
  }

  toggleFavorite() {
    // optimistic UI
    this.updateCounter();
    this.updateCounterVisibility();
    this.toggleActiveClass();
    this.updateSaveText();

    return fetch('/api/inventory/favorite/', {
      method: 'POST',
      body: JSON.stringify({
        stock_id: this.stockId,
      }),
      headers: {
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      if (!response.ok) {
        // revert UI
        this.updateCounter();
        this.updateCounterVisibility();
        this.toggleActiveClass();
        this.updateSaveText();
        return;
      }

      if (this.isActive()) {
        this.notifyAdded();
      }
    });
  }

  notifyAdded() {
    const details = this.favoriteProductDetails();

    addSnackbar({
      template: SNACKBAR_TEMPLATES.IMAGE_WITH_LINK,
      text: 'Added to Favorites.',
      link: {
        text: 'My Favorites',
        href: details.favorites_url,
      },
      image: details.image_path,
    });
  }

  favoriteProductDetails() {
    if (!this.favoriteProduct) return null;

    const decoded = atob(this.favoriteProduct);
    return JSON.parse(decoded);
  }

  toggleActiveClass() {
    this.$container.classList.toggle(FavoriteButton.activeClass);
  }

  isActive() {
    return this.$container.classList.contains(FavoriteButton.activeClass);
  }

  updateCounter() {
    if (this.isActive()) {
      this.decrementCounter();
      return;
    }

    this.incrementCounter();
  }

  updateCounterVisibility() {
    const counter = this.getCounter();

    if (!counter) return;

    counter.ariaHidden = this.count === 0;
  }

  getCounter() {
    return document.querySelector(FavoriteButton.counterSelector);
  }

  incrementCounter() {
    const counter = this.getCounter();

    if (!counter) return;

    const newCount = parseInt(counter.textContent) + 1;
    counter.querySelector('span').textContent = newCount;
    counter.dataset.numberOfFavorites = newCount;
  }

  decrementCounter() {
    const counter = this.getCounter();

    if (!counter) return;

    const newCount = parseInt(counter.textContent) - 1;

    counter.querySelector('span').textContent = newCount;
    this.count = newCount;
    counter.dataset.numberOfFavorites = newCount;
  }

  updateSaveText() {
    if (this.isActive()) {
      document.querySelectorAll(FavoriteButton.saveClass).forEach((el) => {
        // eslint-disable-next-line no-param-reassign
        el.textContent = 'Saved';
      });
    } else {
      document.querySelectorAll(FavoriteButton.saveClass).forEach((el) => {
        // eslint-disable-next-line no-param-reassign
        el.textContent = 'Save';
      });
    }
  }

  get count() {
    const counter = this.getCounter();

    if (!counter) return;

    return parseInt(counter.dataset.numberOfFavorites);
  }

  set count(newCount) {
    const counter = this.getCounter();

    if (!counter) return;

    counter.dataset.numberOfFavorites = newCount;
  }
}
